import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
  Table,
} from "reactstrap";
import { toast } from "react-toastify";
import axiosInstance from "../../helpers/axiosInstance"; // Your axios instance


// PLACEHOLDER - Replace with your actual Breadcrumbs component
const Breadcrumbs = ({ title, breadcrumbItems }) => (
  <div>
    <h3>{title}</h3>
    <ul>
      {breadcrumbItems.map((item) => (
        <li key={item.title}> {item.title} </li>
      ))}
    </ul>
  </div>
);


const VideoList = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [videoData, setVideoData] = useState({ title: "", link: "" });
  const [editVideoId, setEditVideoId] = useState(null);

  const breadcrumbItems = [
    { title: "Toy Hub Admin", link: "/" },
    { title: "Video Links", link: "#" },
  ];

  useEffect(() => {
    fetchVideos();
  }, []);

  const fetchVideos = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/api/v1/video");
      setVideos(response.data);
    } catch (error) {
      console.error("Error fetching videos:", error);
      toast.error("Failed to fetch video links");
    } finally {
      setLoading(false);
    }
  };

  const handleAddVideo = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post("/api/v1/video/create", videoData);
      setVideos([...videos, response.data]);
      toast.success("Video link added successfully!");
      setModal(false);
      setVideoData({ title: "", link: "" });
      fetchVideos()
    } catch (error) {
      console.error("Error adding video:", error);
      toast.error("Failed to add video link");
    }
  };

  const handleDeleteVideo = async (id) => {
    if (window.confirm("Are you sure you want to delete this video link?")) {
      try {
        await axiosInstance.delete(`/api/v1/video/delete/${id}`);
        setVideos(videos.filter((video) => video._id !== id));
        toast.success("Video link deleted successfully!");
      } catch (error) {
        console.error("Error deleting video:", error);
        toast.error("Failed to delete video link");
      }
    }
  };

  const handleEditVideo = async (id) => {
    setEditVideoId(id);
    const video = videos.find((v) => v._id === id);
    setVideoData({ title: video.title, link: video.link });
    setModal(true);
  };

  const handleUpdateVideo = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.put(`/api/v1/video/update/${editVideoId}`, videoData);
      const updatedVideos = videos.map((video) =>
        video._id === editVideoId ? { ...video, ...videoData } : video
      );
      setVideos(updatedVideos);
      toast.success("Video link updated successfully!");
      setModal(false);
      setVideoData({ title: "", link: "" });
      setEditVideoId(null);
    } catch (error) {
      console.error("Error updating video:", error);
      toast.error("Failed to update video link");
    }
  };

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center">
            <Spinner color="primary" />
          </div>
        </Container>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Video Links" breadcrumbItems={breadcrumbItems} />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="card-title mb-0">Manage Video Links</h4>
                    <Button color="primary" onClick={() => setModal(true)}>
                      Add New Video Link
                    </Button>
                  </div>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th>Link</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {videos.map((video) => (
                        <tr key={video._id}>
                          <td>{video.title}</td>
                          <td>{video.link}</td>
                          <td>
                            <Button
                              color="warning"
                              size="sm"
                              className="me-2"
                              onClick={() => handleEditVideo(video._id)}
                            >
                              Edit
                            </Button>
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => handleDeleteVideo(video._id)}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={() => setModal(false)}>
            <ModalHeader toggle={() => setModal(false)}>
              {editVideoId ? "Edit Video Link" : "Add Video Link"}
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={editVideoId ? handleUpdateVideo : handleAddVideo}>
                <FormGroup>
                  <Label for="title">Video Title</Label>
                  <Input
                    type="text"
                    id="title"
                    name="title"
                    value={videoData.title}
                    onChange={(e) =>
                      setVideoData({ ...videoData, title: e.target.value })
                    }
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="link">Video Link</Label>
                  <Input
                    type="text"
                    id="link"
                    name="link"
                    value={videoData.link}
                    onChange={(e) =>
                      setVideoData({ ...videoData, link: e.target.value })
                    }
                    required
                  />
                </FormGroup>
                <Button type="submit" color="primary">
                  {editVideoId ? "Update" : "Add"}
                </Button>
              </Form>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default VideoList;